const usersReducers = {
  admin: 'Administrator',
  analyst: 'Documentation Analyst',
  contractor: 'Third party company'
};

export default usersReducers;
